import type { EnrollCourse201OneOfResult } from './enrollCourse201OneOfResult';

export type EnrollCourse201OneOf = {
  /** 수강신청 일시 */
  enrolledAt: string;
  /** 생성된 수강신청 ID */
  enrollmentId: string;
  /** 수강신청 번호 */
  enrollmentNumber: string;
  result: EnrollCourse201OneOfResult;
  /**
   * 수강 유효 기간
   * @nullable
   */
  validUntil?: string | null;
};
